// Pricing ladder + membership matrix content (display copy).
// lookup_key values must match backend payments.py CATALOG.

export const TIERS = [
  {
    slug: "client_premium",
    name: "Client Supporter",
    audience: "Customers",
    tagline: "Find and follow serious barbers.",
    monthly: 4.99,
    yearly: 49.9,
    monthlyKey: "client_premium_monthly",
    yearlyKey: "client_premium_yearly",
    freeAvailable: true,
    highlight: false,
    features: [
      "Save favorite barbers",
      "Faster access to featured barbers",
      "Booking & contact shortcuts",
      "Event alerts",
      "Exclusive offers & product drops",
    ],
  },
  {
    slug: "insider",
    name: "Barber Insider",
    audience: "Barbers",
    tagline: "Get into the ecosystem.",
    monthly: 9.99,
    yearly: 99,
    monthlyKey: "insider_monthly",
    yearlyKey: "insider_yearly",
    highlight: false,
    features: [
      "Industry news & trend reports",
      "Tips, tricks & new gear drops",
      "Community access",
      "Limited profile visibility",
      "Basic member status",
      "Access to selected resources",
    ],
  },
  {
    slug: "certified",
    name: "Quality Certified",
    audience: "Barbers · Booked Barber",
    tagline: "Get booked. Client messages, leads & the trust badge.",
    monthly: 49.99,
    yearly: 499,
    monthlyKey: "certified_monthly",
    yearlyKey: "certified_yearly",
    highlight: true,
    badge: "Most Popular",
    features: [
      "Barbistry Quality Certified badge",
      "Better local search ranking",
      "Public trust marker on profile",
      "Private client messages & lead access",
      "Full profile with portfolio & specialties",
      "Member-only education & premium content",
      "Eligibility for features & spotlights",
    ],
  },
  {
    slug: "featured",
    name: "Featured Pro",
    audience: "Barbers",
    tagline: "Serious growth & premium positioning.",
    monthly: 99.99,
    yearly: 999,
    monthlyKey: "featured_monthly",
    yearlyKey: "featured_yearly",
    highlight: false,
    features: [
      "Everything in Quality Certified",
      "Featured placement in city/category pages",
      "Priority spotlight opportunities",
      "Social media promotion support",
      "Interview / article opportunities",
      "Enhanced analytics",
      "Event participation priority",
    ],
  },
  {
    slug: "shop_standard",
    name: "Shop",
    audience: "Shops",
    tagline: "Grow your whole team.",
    monthly: 149,
    yearly: 1490,
    monthlyKey: "shop_standard_monthly",
    yearlyKey: "shop_standard_yearly",
    highlight: false,
    features: [
      "Shop profile page & branding",
      "Team listings & lead routing",
      "Local search visibility",
      "Promotions & announcements",
      "Hiring visibility",
      "Shop-level analytics",
      "Featured weekly shop drops (Featured plan)",
    ],
  },
  {
    slug: "vendor_entry",
    name: "Vendor / Brand",
    audience: "Vendors",
    tagline: "Reach the right audience.",
    monthly: 99,
    yearly: 990,
    monthlyKey: "vendor_entry_monthly",
    yearlyKey: "vendor_entry_yearly",
    highlight: false,
    features: [
      "Product listings",
      "Sponsored placements",
      "Featured drops",
      "Brand promotion to barber audience",
      "Launch support",
      "Campaign visibility",
      "Affiliate / marketplace opportunities",
    ],
  },
  {
    slug: "educator",
    name: "Educator",
    audience: "Educators",
    tagline: "Get paid to teach.",
    monthly: 149,
    yearly: 1490,
    monthlyKey: "educator_monthly",
    yearlyKey: "educator_yearly",
    highlight: false,
    features: [
      "Host paid educational sessions",
      "Run Zoom / video-based lessons",
      "Sell event tickets",
      "Get featured as educator",
      "Course or book promotion",
      "Replay library access",
      "70–80% payout on ticket sales",
    ],
  },
];

export const MATRIX = {
  columns: ["insider", "certified", "featured", "shop_standard", "vendor_entry", "educator"],
  rows: [
    { label: "Industry news & drops", values: [true, true, true, true, true, true] },
    { label: "Community access", values: [true, true, true, true, true, true] },
    { label: "Public profile", values: ["Limited", "Full", "Full", "Shop", "Brand", "Full"] },
    { label: "Quality Certified badge", values: [false, true, true, false, false, false] },
    { label: "Lead access & private messages", values: [false, true, true, true, false, false] },
    { label: "Better local search ranking", values: [false, true, true, true, false, false] },
    { label: "Featured placement", values: [false, false, true, "Add-on", true, true] },
    { label: "Social promo support", values: [false, false, true, true, true, true] },
    { label: "Analytics", values: [false, "Basic", "Enhanced", "Shop", "Campaign", "Basic"] },
    { label: "Monetization tools", values: [false, false, false, false, true, true] },
    { label: "Host / sell events", values: [false, false, false, false, false, true] },
  ],
};

export function usd(n) {
  return n % 1 === 0 ? `$${n}` : `$${n.toFixed(2)}`;
}
